import React, { useContext, useState, useEffect } from "react";

import { PopUpContext } from "../../contexts/popUpContext";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import Img from "../common/Img";

import CalendarIcon from "../../icons/calendar-icon";
import SaawisLogo from "../../icons/saawis-logo";

const BottomControls = () => {
  const { togglePopUp } = useContext(PopUpContext);

  const [user, setUser] = useState([]);

  useEffect(() => {
    const ac = new AbortController();

    db.getAll("login")
      .then((res) => setUser(res?.data?.data?.[0] || {}))
      .catch(() => setUser({}));

    return () => ac.abort();
  }, []);

  return (
    <div className="bottom-controls">
      <ul>
        <div className="control">
          <div
            className="avatar"
            onClick={() => togglePopUp({ form: "entry-year-pop-up" })}
          >
            <CalendarIcon />
          </div>
          <span>{lbl.Semester}</span>
        </div>
        <div
            className="control"
            onClick={() => togglePopUp({ form: "user-profile-pop-up" })}
        >
          <div className="avatar">
            <div className="user-profile">
              <Img src={user?.photo} border={false} />
            </div>
          </div>
          <span>{user?.name}</span>
        </div>
        <div
          className="control saawis"
          // onClick={() => firebase.auth().signOut()}
        >
          <SaawisLogo />
        </div>
      </ul>
    </div>
  );
};

export default BottomControls;
